import { Component, EventEmitter, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { ERoutes } from 'src/app/core/enums/routes.enum';
import { IParsedTripLeg } from 'src/app/core/types/interfaces/trip-elements.interface';

import { HeaderStateService } from 'src/app/core/services/header-state.service';

import { PreviewMapComponent } from 'src/app/shared/maps/preview-map/preview-map.component';
import { GetFavoritesByProvider } from '../user-wish-list-page/measure-amount-of-favorites.pipe';

@Component({
    selector: 'app-preview-trip-sheet',
    imports: [
        PreviewMapComponent,
        MatIcon,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        GetFavoritesByProvider,
    ],
    templateUrl: './preview-trip-sheet.component.html',
    styleUrl: './preview-trip-sheet.component.scss'
})
export class PreviewTripSheetComponent {
  protected readonly eSvgIcons = ESvgIcons;
  public readonly actionEmitter = new EventEmitter<string>();
  public legs: IParsedTripLeg[] = [];

  readonly #router = inject(Router);
  readonly #headerStateService = inject(HeaderStateService);
  readonly #bottomSheetRef =
    inject<MatBottomSheetRef<PreviewTripSheetComponent>>(MatBottomSheetRef);

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      trip: any;
      duration: string;
      extraTripInfo: any;
      tripDestinations: any;
      destinationsRoute: any;
    },
  ) {
    this.#headerStateService.isBackBtnPresent = true;
    this.#headerStateService.backBtnClickEmmit
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.dismissPreviewTrip());
  }

  public setParsedTripLegs(legs: IParsedTripLeg[]): void {
    this.legs = legs;
  }

  public onEditTrip(): void {
    this.#router
      .navigate([ERoutes.TRIP_PLANNER, this.data.trip.visible_id])
      .then(() => {
        this.#bottomSheetRef.dismiss();
        this.#headerStateService.isBackBtnPresent = false;
      });
  }

  public dismissPreviewTrip(): void {
    this.#bottomSheetRef.dismiss();
    this.#headerStateService.isBackBtnPresent = false;
  }
}
